import { getAuthenticationToken } from '@zaplify/utils';
import { getZaplifySdk } from '@zaplify/sdk';
import { LocalStorageKeys } from '../../config';
import { CreateUserDto } from '@zaplify/users/shared';

interface CreateUserArg {
    data: {
        firstName?: string;
        lastName?: string;
        country?: string;
        website?: string;
        companyName?: string;
        companyDomain?: string;
        isSubscribed?: boolean;
        isTestSpace?: boolean;
    };
    authUser: {
        authUserId: string;
        authUserEmail: string;
        domain: string;
    } | null;
    referralLinkId: string | null;
    joinByDomain: { organizationId: string; domain: string } | null;
    joinByInvitation: { invitationId: string; organizationId: string } | null;
    createOrganization: {} | null;
}

const getAnonymousId = (): string => {
    const cookies = document.cookie;
    let anonymousId = null;
    const cookiesArray = cookies.split('; ');
    for (let cookie of cookiesArray) {
        if (cookie.startsWith('ajs_anonymous_id=')) {
            anonymousId = cookie.split('=')[1];
            return anonymousId;
        }
    }
};

export const useCreateUser = () => {
    const createUser = async ({
        data,
        authUser,
        joinByDomain,
        joinByInvitation,
        createOrganization,
        referralLinkId,
    }: CreateUserArg) => {
        try {
            const anonymousId = getAnonymousId();
            const parsedCountry = data.country?.split(' ')[1];

            console.log({
                message: 'the info',
                anonymousId,
                parsedCountry,
                authUser,
                joinByDomain,
                joinByInvitation,
                createOrganization,
            });

            if (!authUser) {
                throw new Error('Could not determine the logged in user');
            }

            let createUserDto: CreateUserDto;
            if (joinByInvitation) {
                createUserDto = {
                    anonymousId: anonymousId,
                    firebaseId: authUser.authUserId,
                    email: authUser.authUserEmail,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    location: {
                        country: parsedCountry,
                        city: '',
                    },
                    isSubscribed: data.isSubscribed,
                    referredByReferralLinkId: referralLinkId,
                    joinByInvitation: {
                        id: joinByInvitation.invitationId,
                        organizationId: joinByInvitation.organizationId,
                    },
                };
            } else if (joinByDomain) {
                createUserDto = {
                    anonymousId: anonymousId,
                    firebaseId: authUser.authUserId,
                    email: authUser.authUserEmail,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    location: {
                        country: parsedCountry,
                        city: '',
                    },
                    isSubscribed: data.isSubscribed,
                    referredByReferralLinkId: referralLinkId,
                    joinByDomain: {
                        // @TODO Require organizationId as well for security purposes..?
                        domain: joinByDomain.domain,
                    },
                };
            } else if (createOrganization) {
                createUserDto = {
                    anonymousId: anonymousId,
                    firebaseId: authUser.authUserId,
                    email: authUser.authUserEmail,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    location: {
                        country: parsedCountry,
                        city: '',
                    },
                    isSubscribed: data.isSubscribed,
                    referredByReferralLinkId: referralLinkId,
                    createOrganization: {
                        name: data.companyName,
                        domain: data.companyDomain,
                        website: data.website,
                        isTestSpace: data.isTestSpace,
                    },
                };
            } else {
                throw new Error('Unsupported scenario');
            }

            const andsendUser = await getZaplifySdk().profiles.user.createUser(createUserDto);
            if (!andsendUser) {
                return;
            }

            localStorage.removeItem(LocalStorageKeys.REFERRAL_LINK);
            localStorage.removeItem(LocalStorageKeys.INVITATION_ID);
            localStorage.removeItem(LocalStorageKeys.INVITATION_SECURITY_TOKEN);

            // Important that we make sure the auth token is refreshed also after creating the new user, so that subsequent requests are made using correct user
            await getAuthenticationToken(true);

            const addrevenue = window['ADDREVENUE'];
            if (addrevenue) {
                try {
                    addrevenue.sendEvent('Signup', { orderId: andsendUser.userOrganizationId });
                } catch (error) {
                    console.error('Addrevnue error while sending Signup event', error);
                }
            } else {
                console.warn('Addrevnue not loaded');
            }

            return andsendUser;
        } catch (error) {
            throw new Error('Error configuring profile. Try again later', {
                cause: error,
            });
        }
    };

    return { createUser };
};
